export class Aka {
  id: number;
  aka_type_id: number;
  contact_id: number;
  name: string;
  position: number;
  deleting: boolean = false;
  editing: boolean = false;
  type_name: string;
}
